function supportsRecording() {
  return typeof navigator.mediaDevices === 'object' && typeof navigator.mediaDevices.getUserMedia === 'function';
}

function supportsTTS() {
  return 'speechSynthesis' in window;
}

function supportsSpeechRecognition() {
  const SpeechRecognition = window.SpeechRecognition ||
    window.webkitSpeechRecognition ||
    window.mozSpeechRecognition ||
    window.msSpeechRecognition ||
    window.oSpeechRecognition;

  return typeof SpeechRecognition === 'function';
}

export default {
  recording: supportsRecording,
  tts: supportsTTS,
  speechRecognition: supportsSpeechRecognition,
};



// WEBPACK FOOTER //
// ./src/modules/supports.js